<template>
  <div class="select-store-component">
    <el-dialog
      :title="$t('lcd.Devices.Bind Item')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      custom-class="dialog-bind-item"
      width="800px"
      append-to-body
    >
      <div class="select-store-bd">
        <el-descriptions>
          <el-descriptions-item :label="$t('lcd.Devices.Store Name')">{{
            detailData.storeName
          }}</el-descriptions-item>
          <el-descriptions-item :label="$t('lcd.Devices.Device ID')">{{
            detailData.code
          }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions>
          <el-descriptions-item :label="$t('lcd.Devices.Bind Item')">
            <el-select
              size="small"
              v-model="value"
              multiple
              filterable
              remote
              reserve-keyword
              :placeholder="$t('lcd.Devices.Please Enter Item')"
              :remote-method="remoteMethod"
              :loading="loading"
              style="width: 200px"
              ref="itemSelectRef"
            >
              <el-option
                v-for="item in options"
                :key="item.itemCode"
                :label="item.itemName"
                :value="item.itemCode"
                @click.native="handleAddItem(item)"
              >
                <span style="float: left">{{ item.itemCode }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  item.itemName
                }}</span>
              </el-option>
            </el-select>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <!-- {{detailData.bindItem}}
      bindItemList:{{ bindItemList }} -->
      <el-descriptions :column="1" :title="$t('lcd.Devices.Binded List')">
        <el-descriptions-item
          v-for="(o, index) in bindItemList"
          :label="index + 1"
          :key="o.itemCode"
        >
          <el-tag>{{ o.itemCode }}</el-tag>
          <span style="margin: 0 10px">{{ o.itemName }}</span>
          <!-- <span
            class="itemBtn"
            style="margin: 0 10px; color: #35b871"
            @click="handleReplaceBind(index)"
            >替换</span
          > -->
          <span class="itemBtn" @click="handleDeleteBind(index)">{{$t('lcd.Devices.Delete')}}</span>
        </el-descriptions-item>
      </el-descriptions>

      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          @click="handleClose('cancel')"
          style="background: #d4d4d4"
          >{{ $t("button.Cancel") }}</el-button
        >
        <el-button
          size="small"
          class="base-color-btn"
          type="success"
          @click="handleConfirm('confirm')"
          >{{ $t("button.Confirm") }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getItemList,screenItemBind } from "@/libs/api/lcd";
export default {
  name: "selectStore",
  components: {},
  props: {
    detailData: {
      type: Object,
      default: {},
    },
    storeType: {
      type: Number,
    },
  },
  data() {
    return {
      dialogVisible: false,
      nextStoreList: [], //列表数据源
      defaultProps: {
        label: "storeName",
        children: "nextStoreList",
      },
      selectedStoreIds: [], // 默认选中的key
      loading: false,
      options: [],
      value: [],
      list: [],
      multiple: false,
      bindItemList: [],
    };
  },
  created() {},
  watch: {
    dialogVisible(val) {
      if (val) {
        console.log("打开了",typeof this.detailData.bindItem);
        this.bindItemList = JSON.parse(this.detailData.bindItem)
      }
    },
  },
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        let userData = JSON.parse(localStorage.getItem("userData"));
        const params = {
          storeId: localStorage.getItem("storeId"),
          scenarioId: userData.defaultScenarioId1,
          itemInfo: query,
          findBy: "0",
          current: "1",
          size: "100",
          storeType: this.storeType,
        };
        getItemList(params).then((res) => {
          console.log(res);
          this.loading = false;
          this.options = res.data.data.records;
        });

        // setTimeout(() => {
        //   this.loading = false;
        //   this.options = this.list.filter((item) => {
        //     return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        //   });
        // }, 200);
      } else {
        this.options = [];
      }
    },
    open() {
      this.dialogVisible = true;
    },
    handleAddItem(item) {
      console.log("bindItem", item);
      console.log(this.$refs.itemSelectRef.visible);
      this.$refs.itemSelectRef.visible = false;
      this.options = [];
      this.bindItemList.push(item);
      this.value = "";
    },
    handleDeleteBind(index) {
      this.bindItemList.splice(index, 1);
    },
    handleReplaceBind(index) {
      this.replaceIndex = index;
    },
    // 获取数据
    async getData() {
      let userData = JSON.parse(localStorage.getItem("userData"));
      const params = {
        storeId: userData.storeId,
        scenarioId: userData.defaultScenarioId,
        itemInfo: "",
        findBy: "",
        current: "1",
        size: "100",
      };
      try {
        const res = await getItemList(params);
        let response = res.data;
        if (response.state) {
          const data = res.data?.data;
          if (this.hasOwnerLevel) {
            let arr = [data];
            this.nextStoreList = arr;
          } else {
            this.nextStoreList = data?.nextStoreList;
          }
        } else {
          this.$message.error(response.message);
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 取消选择
    handleClose() {
      this.bindItemList = [];
      this.dialogVisible = false;
    },
    // 点击确定
    handleConfirm() {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const params = {
        sn: this.detailData.code,
        itemCodes: this.bindItemList.map(item => item.itemCode),
        storeId: userData.storeId,
        taskTerminal:  0,
      };
      console.log(params)
      screenItemBind(params).then(res => {
        console.log(res)
        if(res.data.code == 1){
          this.$message.success(this.$t('lcd.Devices.Bind Success'))
          this.dialogVisible = false;
          this.$emit("reGetList");
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-bind-item {
  margin-top: 0 !important;
  margin-bottom: 0;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  .el-dialog__body {
    height: 400px;
    padding: 20px;
    box-sizing: border-box;
  }
  ::v-deep
    .el-descriptions__body
    .el-descriptions__table
    .el-descriptions-item__cell {
    line-height: 28px !important;
    background-color: pink;
  }
  .select-store-bd {
    margin: 0 auto;
    width: 80%;
    ::v-deep .el-radio {
      margin-top: 5px;
      padding: 10px 0;
      width: 100%;
    }
  }
  .box {
    height: 330px;
    margin-top: 20px;
  }
  .el-table thead {
    display: none;
  }
  .el-button {
    width: 110px;
  }
  .el-tree-node__content {
    height: 45px;
  }
  .el-table td.el-table__cell {
    border: none;
    width: 100%;
  }
  .el-table td.el-table__cell > .cell {
    justify-content: flex-start;
  }
  .el-table__row {
    display: flex;
  }
  // ::v-deep .el-radio{
  //   margin-top: 5px;
  //   padding: 20px 0;
  //   width: 100%;
  // }
  ::v-deep .el-table {
    .el-table__header {
      width: 100% !important;
    }
    th.el-table__cell > .cell {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
    }
    td.el-table__cell > .cell {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .is-group tr:nth-child(2) .el-checkbox {
      display: none;
    }
  }

  // 重置样式
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .el-dialog__footer {
    padding: 20px 0;
  }
  .el-radio {
    padding: 14px 0;
    margin-bottom: 0;
  }

  .itemBtn {
    cursor: pointer;
    color: red;
  }
}
</style>